// =============================================================================
// src/lib/format-distance.ts
//
// Single helper for formatting a (meters, miles) pair into the human-
// readable distance string the SPA shows in the result panel. Below
// 0.8 mi we render rounded feet ("324 ft") so coords right at a
// border don't all look like "0.06 mi"; above we render miles
// to 1 decimal ("12.4 mi"). The threshold is high enough that
// typical city-scale civic-layer distances still read in miles.
// =============================================================================

/** Exact meter-to-feet conversion (1 m = 3.28084 ft). */
export const METERS_TO_FEET = 3.28084

/** Threshold below which distance is displayed in feet. */
export const FEET_THRESHOLD_MILES = 0.8

/**
 * Format a distance from a (meters, miles) pair into the panel
 * display string. Feet derived from meters (more precision than
 * miles) below the threshold; miles otherwise.
 */
export function formatDistance(meters: number, miles: number): string {
  if (miles < FEET_THRESHOLD_MILES) {
    const feet = Math.round(meters * METERS_TO_FEET)
    return `${feet.toLocaleString('en-US')} ft`
  }
  return `${miles.toFixed(1)} mi`
}
